/* eslint-disable jsx-a11y/anchor-is-valid */
import { useNavigate } from 'react-router-dom'
import { useApp } from '../store.jsx'
import { Icon, ThemeToggleBtn } from '../components/Common.jsx'
import ChatBot from '../components/ChatBot'

export default function Landing() {
  const navigate = useNavigate()
  const { navDrawerOpen, setNavDrawerOpen, toast } = useApp()
  const closeDrawer = () => setNavDrawerOpen(false)

  return (
    <div className="landing">
      <nav className="nav">
        <a className="nav-logo" href="#">
          <span className="nav-logo-icon"><Icon name="bar-chart-3" size={16} /></span>
          REPORTFLOW
        </a>
        <div className="nav-links">
          <a href="#features">Features</a>
          <a href="#how">How It Works</a>
          <a href="#pricing">Pricing</a>
          <a href="#" onClick={(e) => { e.preventDefault(); navigate('/signin') }}>Login</a>
        </div>
        <div className="nav-actions">
          <ThemeToggleBtn width={38} />
          <button className="btn btn-primary nav-cta-desktop" onClick={() => navigate('/signup')}>Get Started <Icon name="arrow-right" size={16} /></button>
          <button className="icon-btn nav-toggle" onClick={() => setNavDrawerOpen(true)} style={{ display: 'none', width: 38, height: 38 }}><Icon name="menu" size={16} /></button>
        </div>
      </nav>

      <div className={`nav-back ${navDrawerOpen ? 'open' : ''}`} onClick={closeDrawer} />
      <div className={`nav-drawer ${navDrawerOpen ? 'open' : ''}`}>
        <a href="#features" onClick={closeDrawer}>Features</a>
        <a href="#how" onClick={closeDrawer}>How It Works</a>
        <a href="#pricing" onClick={closeDrawer}>Pricing</a>
        <a href="#" onClick={(e) => { e.preventDefault(); closeDrawer(); navigate('/signin') }}>Login</a>
        <button className="btn btn-primary" onClick={() => { closeDrawer(); navigate('/signup') }}>Get Started <Icon name="arrow-right" size={16} /></button>
      </div>

      <section className="hero">
        <div className="hero-grid">
          <div>
            <div className="hero-badge">
              <span className="badge-dot" />
              New: WhatsApp Bot v2 — Smarter AI Summaries
            </div>
            <h1>Daily reports that <span className="accent">write themselves</span> on WhatsApp.</h1>
            <p>Your team submits via WhatsApp in 30 seconds. Our AI structures every message into beautiful dashboards — no apps, no logins, no chasing.</p>
            <div className="hero-actions">
              <button className="btn btn-primary btn-lg" onClick={() => navigate('/signup')}>Start Free Trial <Icon name="arrow-right" size={16} /></button>
              <button className="btn btn-ghost btn-lg" onClick={() => toast('Demo video coming soon', 'info')}><Icon name="play-circle" size={16} /> Watch 2-min Demo</button>
            </div>
            <div className="hero-meta">
              <div className="avatar-stack">
                {[['AS', '#F59E0B'], ['PR', '#EC4899'], ['VK', '#10B981'], ['MN', '#3B82F6']].map(([t, c], i) => (
                  <div key={i} className="avatar" style={{ background: `linear-gradient(135deg,${c},#7C3AED)` }}>{t}</div>
                ))}
                <div className="avatar" style={{ background: 'var(--surface-3)', color: 'var(--text)' }}>+9k</div>
              </div>
              <div className="hero-meta-item"><Icon name="check-circle-2" size={16} /> 14-day free trial</div>
              <div className="hero-meta-item"><Icon name="check-circle-2" size={16} /> No credit card</div>
            </div>
          </div>

          <div className="hero-visual">
            <div className="hero-glow" />
            <div className="float-card float-card-1">
              <div className="fc-head">
                <div className="fc-icon green"><Icon name="trending-up" size={14} /></div>
                <div><div className="fc-title">Compliance rate</div><div className="fc-sub">Last 7 days</div></div>
              </div>
              <div className="fc-value">94%</div>
              <div className="fc-bar"><div className="fc-bar-fill" /></div>
              <div className="fc-row"><span style={{ color: 'var(--text-muted)' }}>+5% vs prev week</span><span style={{ color: 'var(--success)', fontWeight: 600 }}>↑</span></div>
            </div>
            <div className="float-card float-card-2">
              <div className="fc-head">
                <div className="fc-icon"><Icon name="file-text" size={14} /></div>
                <div><div className="fc-title">Reports today</div><div className="fc-sub">Live · auto-updating</div></div>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
                <div className="fc-value">142</div>
                <div className="badge badge-success" style={{ fontSize: 10 }}>+12%</div>
              </div>
              <div className="fc-spark">
                {[40, 60, 35, 75, 55, 80, 95].map((h, i) => <span key={i} style={{ height: h + '%', opacity: i >= 5 ? 1 : 0.85, background: i === 6 ? 'var(--primary-2)' : 'var(--primary)' }} />)}
              </div>
            </div>
            <div className="phone">
              <div className="phone-notch" />
              <div className="phone-status">
                <span>9:41</span>
                <span style={{ display: 'flex', gap: 5, alignItems: 'center' }}>
                  <Icon name="signal" size={12} /><Icon name="wifi" size={12} /><Icon name="battery-full" size={14} />
                </span>
              </div>
              <div className="phone-wa-head">
                <Icon name="chevron-left" size={18} className="" />
                <div className="phone-wa-avatar"><Icon name="message-circle" size={18} /></div>
                <div style={{ flex: 1 }}>
                  <div className="phone-wa-name">ReportFlow Bot</div>
                  <div className="phone-wa-sub">online · last seen now</div>
                </div>
                <Icon name="video" size={18} />
                <Icon name="phone" size={16} />
              </div>
              <div className="phone-wa-body">
                <div className="bubble in">
                  <div className="bot-tag">REPORTFLOW BOT</div>
                  Good morning Aarav!<br />Reply <b>YES</b> to start your day, or <b>SKIP</b> if you're on leave today.
                  <div className="bubble-time">9:00 AM</div>
                </div>
                <div className="bubble out">
                  YES
                  <div className="bubble-time">9:01 AM ✓✓</div>
                </div>
                <div className="bubble in">
                  <div className="bot-tag">REPORTFLOW BOT</div>
                  Hey Aarav! 👋<br />Reply 'add task: &lt;description&gt;' to add a task, or I'll prompt you at 6 PM for status updates.
                  <div className="bubble-time">9:01 AM</div>
                </div>
                <div className="bubble out">
                  add task: Reviewed PR #482
                  <div className="bubble-time">10:00 AM ✓✓</div>
                </div>
                <div className="bubble in">
                  ✅ Task added: "Reviewed PR #482"
                  <div className="bubble-time">10:00 AM</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="trust-bar">
        <p>Trusted by 150+ companies worldwide</p>
        <div className="trust-logos">
          {['NORTHWIND', 'ACME CO', 'STELLAR', 'QUANTUM', 'ZENITH', 'VERTEX'].map(n => <span key={n}>{n}</span>)}
        </div>
      </div>

      <section className="section" id="features">
        <div className="section-head">
          <span className="eyebrow">Features</span>
          <h2>Everything your team needs to report smarter</h2>
          <p>Replace status meetings, scattered messages, and manual spreadsheets with one intelligent platform.</p>
        </div>
        <div className="features-grid">
          {[
            { icon: 'sparkles', t: 'AI Structured Reports', d: 'Convert plain employee messages into structured daily reports with tasks, hours, blockers, and progress automatically.' },
            { icon: 'message-circle', t: 'WhatsApp Integration', d: 'Employees submit reports directly through WhatsApp. No new app to install. Works on every phone.' },
            { icon: 'bar-chart-3', t: 'Weekly Analytics', d: 'Beautiful dashboards for admins, managers, and employees with drill-down insights and exportable reports.' },
            { icon: 'bell', t: 'Smart Reminders', d: 'Auto-remind employees who haven\'t submitted, with custom timing per team and timezone awareness.' },
            { icon: 'shield-check', t: 'Role-Based Access', d: 'Granular permissions for super admins, admins, managers, employees, and viewers across every module.' },
            { icon: 'download-cloud', t: 'Export Anywhere', d: 'Push reports to email, Slack, Google Sheets, or download as PDF and CSV with one click.' }
          ].map(f => (
            <div key={f.t} className="feature-card">
              <div className="feature-icon"><Icon name={f.icon} size={22} /></div>
              <h3>{f.t}</h3>
              <p>{f.d}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="section" id="how" style={{ background: 'var(--bg-2)', borderTop: '1px solid var(--border)', borderBottom: '1px solid var(--border)' }}>
        <div className="section-head">
          <span className="eyebrow">How it works</span>
          <h2>From zero to insights in under 5 minutes</h2>
          <p>Set up your team, connect WhatsApp, and start receiving structured reports immediately.</p>
        </div>
        <div className="steps">
          {[
            { n: 1, t: 'Manager Adds Employees', d: 'Invite your team via email or bulk-import a CSV. Assign roles and departments.' },
            { n: 2, t: 'Employees Get Reminders', d: 'Daily WhatsApp pings at configurable times. No app, no login required.' },
            { n: 3, t: 'AI Processes Reports', d: 'Our AI extracts tasks, hours, blockers, and sentiment from natural language messages.' },
            { n: 4, t: 'Dashboard Shows Insights', d: 'Real-time analytics, weekly trends, and exportable reports — all in one place.' }
          ].map(s => (
            <div key={s.n} className="step">
              <div className="step-num">{s.n}</div>
              <h3>{s.t}</h3>
              <p>{s.d}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="section" id="pricing">
        <div className="section-head">
          <span className="eyebrow">Pricing</span>
          <h2>Simple, transparent pricing</h2>
          <p>Start free. Upgrade when you grow. Cancel anytime — no questions asked.</p>
        </div>
        <div className="pricing-grid">
          {[
            { name: 'Starter', intent: 'starter', desc: 'Perfect for small teams getting started', price: '₹999', per: '/month', users: 'Up to 20 employees', feats: ['WhatsApp bot integration', 'AI-structured reports', 'Daily & weekly analytics', 'Email reminders', 'CSV exports', 'Email support'], cta: 'Start Free Trial', primary: false },
            { name: 'Growth', intent: 'growth', desc: 'For growing teams that need more power', price: '₹3,499', per: '/month', users: 'Up to 100 employees', feats: ['Everything in Starter', 'Custom report templates', 'Multi-department hierarchy', 'Slack & Sheets integration', 'Custom reminders & shifts', 'Priority support'], cta: 'Start Free Trial', primary: true, featured: true },
            { name: 'Custom', intent: 'custom', desc: 'Pick your own limits — pay only for what you use', price: 'From ₹500', per: '/month', users: 'Set employees · managers · reports', feats: ['Everything in Growth', '₹12 per employee / month', '₹78 per manager / month', '₹0.25 per report / month', 'Minimums: 5e · 5m · 200r', 'Adjust limits anytime'], cta: 'Build your plan', primary: false }
          ].map(p => (
            <div key={p.name} className={`price-card ${p.featured ? 'featured' : ''}`}>
              {p.featured && <span className="price-tag">Most Popular</span>}
              <h3>{p.name}</h3>
              <p className="price-desc">{p.desc}</p>
              <div className="price-amount"><span className="num">{p.price}</span><span className="per">{p.per}</span></div>
              <div className="price-users">{p.users}</div>
              <ul className="price-features">
                {p.feats.map(f => <li key={f}><Icon name="check" size={16} /> {f}</li>)}
              </ul>
              <button
                className={p.primary ? 'btn btn-primary' : 'btn btn-ghost'}
                style={{ justifyContent: 'center' }}
                onClick={() => navigate(`/signup?intent=${p.intent}`)}
              >
                {p.cta}
              </button>
            </div>
          ))}
        </div>
      </section>

      <footer className="footer">
        <div className="footer-grid">
          <div className="footer-brand">
            <a className="nav-logo" href="#"><span className="nav-logo-icon"><Icon name="bar-chart-3" size={16} /></span> REPORTFLOW</a>
            <p>The AI-powered daily reporting platform built for modern teams. Stop chasing updates.</p>
          </div>
          <div className="footer-col"><h4>Product</h4><ul><li><a href="#features">Features</a></li><li><a href="#pricing">Pricing</a></li><li><a href="#">Integrations</a></li><li><a href="#">Changelog</a></li></ul></div>
          <div className="footer-col"><h4>Company</h4><ul><li><a href="#">About</a></li><li><a href="#">Blog</a></li><li><a href="#">Careers</a></li><li><a href="#">Contact</a></li></ul></div>
          <div className="footer-col"><h4>Resources</h4><ul><li><a href="#">Docs</a></li><li><a href="#">Help Center</a></li><li><a href="#">API</a></li><li><a href="#">Status</a></li></ul></div>
          <div className="footer-col"><h4>Legal</h4><ul><li><a href="#">Privacy Policy</a></li><li><a href="#">Terms</a></li><li><a href="#">Security</a></li><li><a href="#">GDPR</a></li></ul></div>
        </div>
        <div className="footer-bottom">
          <span>© 2026 ReportFlow Technologies Pvt Ltd. All rights reserved.</span>
          <div className="social-links">
            <a href="#" aria-label="Twitter"><Icon name="at-sign" size={16} /></a>
            <a href="#" aria-label="LinkedIn"><Icon name="briefcase" size={16} /></a>
            <a href="#" aria-label="GitHub"><Icon name="code-2" size={16} /></a>
            <a href="#" aria-label="YouTube"><Icon name="play" size={16} /></a>
          </div>
        </div>
      </footer>
      <ChatBot mode="public" />
    </div>
  )
}
